import * as z from "zod";

export const COMPLETABLE_PRODUCT_IDS = [
  "chargebacks",
  "contextual",
  "order-editing",
  "recover",
  "returns",
  "shipping-fulfillment",
] as const;
export type CompletableProductId = (typeof COMPLETABLE_PRODUCT_IDS)[number];

export const COMPLETION_REQUIRED_STEP_IDS_BY_PRODUCT = {
  chargebacks: [],
  contextual: ["ctx-subdomain", "ctx-destinations"],
  "order-editing": ["oe-customer-actions", "oe-timing"],
  recover: ["rec-business-info", "rec-messaging"],
  returns: [
    "ret-return-policy",
    "ret-return-options",
    "ret-return-reasons",
    "ret-return-address",
    "ret-communications",
  ],
  "shipping-fulfillment": [
    "sf-current-software",
    "sf-channels",
    "sf-carriers",
    "sf-shipping-automations",
    "sf-order-automations",
    "sf-views",
    "sf-pain-points",
  ],
} as const satisfies Record<CompletableProductId, readonly string[]>;

// Kebab-case only: keeps prototype-mutating keys ("__proto__") and
// server-owned keys ("_team_meta") out of the form_data merge.
export const FINAL_STEP_ID_PATTERN = /^[a-z][a-z0-9-]*$/;

export const COMPLETE_ONBOARDING_FAILURE_REASONS = [
  "no-handler",
  "invalid-final-step",
  "no-progress-row",
  "form-data-incomplete",
  "push-failed",
] as const;
export type CompleteOnboardingFailureReason =
  (typeof COMPLETE_ONBOARDING_FAILURE_REASONS)[number];

export const CompleteOnboardingOutputSchema = z.discriminatedUnion("ok", [
  z.object({ ok: z.literal(true) }),
  z.object({
    ok: z.literal(false),
    reason: z.enum(COMPLETE_ONBOARDING_FAILURE_REASONS),
    missingStepIds: z.array(z.string()).optional(),
  }),
]);
export type CompleteOnboardingOutput = z.infer<
  typeof CompleteOnboardingOutputSchema
>;

export const completeOnboarding = {
  name: "completeOnboarding" as const,
  input: z.object({
    productId: z.enum(COMPLETABLE_PRODUCT_IDS),
    finalStep: z
      .object({
        stepId: z.string().regex(FINAL_STEP_ID_PATTERN),
        stepData: z.record(z.string(), z.unknown()),
      })
      .optional(),
  }),
  output: CompleteOnboardingOutputSchema,
};
